<template>
  <v-app id="app">
    <v-navigation-drawer
      v-model="drawer"
      app
      v-if="!user.isAdmin"
      clipped
      width="220"
    >
      <v-list dense :expand="true">
        <v-list-item
          :to="'/home'"
        >
          <v-list-item-action>
            <v-icon>mdi-home</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              Home
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider  v-if="userClasses.classes.length > 0"></v-divider>
        <v-list-group v-if="userClasses.classes.length > 0"
          v-model="userClasses.model"
          :append-icon="userClasses.model ? 'mdi-chevron-up' : 'mdi-chevron-up'"
          prepend-icon=""
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>
                My Classes
              </v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item
            v-for="(course, i) in userClasses.classes"
            two-line
            :key="i"
            link
            :to="'/class/' + course.uid"
          >
            <v-list-item-content>
              <v-list-item-title>{{ course.uid }}</v-list-item-title>
              <v-list-item-subtitle>{{ course.name }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        <v-divider></v-divider>
        <template v-for="item in items">
          <v-row
            v-if="item.heading"
            :key="item.heading"
            align="center"
          >
            <v-col cols="6">
              <v-subheader v-if="item.heading">
                {{ item.heading }}
              </v-subheader>
            </v-col>
            <v-col
              cols="6"
              class="text-center"
            >
              <a
                href="#!"
                class="body-2 black--text"
              >EDIT</a>
            </v-col>
          </v-row>
          <v-list-group
            v-else-if="item.children"
            :key="item.text"
            v-model="item.model"
            :append-icon="item.model ? item.icon : item['icon-alt']"
            prepend-icon=""
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.text }}
                </v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item
              v-for="(child, i) in item.children"
              :key="i"
              link
              @click="open(child)"
            >
              <v-list-item-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  {{ child.text }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
          </v-list-group>
          <v-list-item
            v-else
            :key="item.text"
            link
            @click="open(item)"
          >
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ item.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      app
      color="red darken-4"
      dark
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title
        style="width: 300px"
        class="ml-0 pl-4"
      >
        <span class="hidden-sm-and-down">THHS|<span style="font-weight:1000">DASH</span></span>
      </v-toolbar-title>
      <v-menu
          v-if="user.isAdmin"

           v-model="search.menu"
           :close-on-content-click="false"
           offset-y
           :nudge-bottom="5"
         >
           <template v-slot:activator="{on}">
             <v-text-field
               v-if="user.isAdmin"
               flat
               v-model="search.text"
               solo-inverted
               hide-details
               prepend-inner-icon="mdi-magnify"
               label="Search"
               v-on="on"
               class="hidden-sm-and-down"
             ></v-text-field>
           </template>

           <v-card flat elevation="0" max-height="80vh">
             <v-list dense two-line v-if="search.results.classrooms && search.results.classrooms.length > 0">
               <v-subheader>Classes</v-subheader>
               <template v-for="(classroom, index) in search.results.classrooms">
                 <v-list-item :key="classroom.uid"
                             :to="'/class/' + classroom.uid"
                             class="pt-0"
                 >
                   <v-list-item-content>
                     <v-list-item-title>{{ classroom.uid }}</v-list-item-title>
                     <v-list-item-subtitle  class="font-weight-light" style="color:black">{{ classroom.name }}</v-list-item-subtitle>
                   </v-list-item-content>
                 </v-list-item>
                 <v-divider v-if="index < search.results.classrooms.length - 1" :key="index"></v-divider>
               </template>
             </v-list>
             <v-divider></v-divider>
             <v-list dense two-line v-if="search.results.students && search.results.students.length > 0">
               <v-subheader>Students</v-subheader>
               <template v-for="(student, index) in search.results.students">
                 <v-list-item :key="student.email"
                             :to="'/home/' + student.email.split('@')[0]"
                 >
                 <v-list-item-icon>
                   <v-icon>mdi-account</v-icon>
                 </v-list-item-icon>
                   <v-list-item-content>
                     <v-list-item-title>{{ student.first_name }} {{ student.last_name }}</v-list-item-title>
                     <v-list-item-subtitle class="font-weight-light" style="color:black">{{ student.email.split('@')[0] }} &centerdot; {{  student.class_of }}</v-list-item-subtitle>
                   </v-list-item-content>
                 </v-list-item>
                 <v-divider v-if="index < search.results.students.length - 1" :key="index"></v-divider>
               </template>
             </v-list>
             <v-divider></v-divider>
             <v-list v-if="search.results.teachers && search.results.teachers.length > 0">
               <v-subheader>Teachers</v-subheader>
               <template v-for="(teacher, index) in search.results.teachers">
                 <v-list-item :key="teacher.uid"
                             :to="'/home/' + teacher.uid.split('@')[0]"
                 >
                 <v-list-item-icon>
                   <v-icon>mdi-account-star</v-icon>
                 </v-list-item-icon>
                   <v-list-item-content>
                     <v-list-item-title>{{ teacher.uid.split('@')[0] }}</v-list-item-title>
                   </v-list-item-content>
                 </v-list-item>
                 <v-divider v-if="index < search.results.teachers.length - 1" :key="index"></v-divider>
               </template>
             </v-list>
          </v-card>
         </v-menu>
         <v-btn  v-if="user.isAdmin" class="hidden-sm-and-down" :loading="search.loading" @click="runSearch" text>Search</v-btn>
      <v-spacer></v-spacer>
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="maroon"
            text
            v-bind="attrs"
            v-on="on"
          >
            {{ user.username }}
            <v-icon>mdi-chevron-down</v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item
            @click="logout"
          >
          <v-list-item-title>Logout</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-btn icon>
        <v-icon>mdi-bell</v-icon>
      </v-btn>
    </v-app-bar>
    <v-main>

      <v-container fluid>
        <keep-alive>

          <router-view
            ref="childComponent"
          />
        </keep-alive>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
const fb = require('../firebaseConfig.js')
const api = require('../apiFunctions.js')

  export default {
    props: {
      source: String,
    },
    data: () => ({
      dialog: false,
      drawer: null,
      search: {
        _timerId: null,
        loading: false,
        text: '',
        menu: false,
        results: {}
      },
      user: fb.session.user,
      userClasses: {
        model: true,
        classes: [
        ]
      },
      items: [
        {
          icon: 'mdi-chevron-up',
          'icon-alt': 'mdi-chevron-down',
          text: 'Admin',
          admin: true,
          model: true,
          children: [
            { icon: 'mdi-bookshelf', text: 'All Classes', path: '/classes/all', query: { status: 'ACTIVE'}},
            { icon: 'mdi-message-video', text: 'Google Meets', path: '/meets',}
          ]
        },
        {
          icon: 'mdi-chevron-up',
          'icon-alt': 'mdi-chevron-down',
          text: 'Reports',
          model: true,
          children: [
            { icon: 'mdi-folder-table-outline', text: 'Daily Attendance'}
          ],
        },
        {
          icon: 'mdi-chevron-up',
          'icon-alt': 'mdi-chevron-down',
          text: 'Accounts',
          admin: true,
          model: true,
          children: [
            { icon: 'mdi-account-multiple', text: 'Students', path: '/students'},
            { icon: 'mdi-account-multiple-plus', text: 'New Students', path: '/students/new'},
            { icon: 'mdi-account-star', text: 'Staff', path: '/staff'},
          ],
        },
        {
          icon: 'mdi-chevron-up',
          'icon-alt': 'mdi-chevron-down',
          text: 'Gsuite Accounts',
          admin: true,
          model: true,
          children: [
            { icon: 'mdi-account-multiple', text: 'Students', path: '/gsuite/students'}
          ],
        },
        {
          icon: 'mdi-chevron-up',
          'icon-alt': 'mdi-chevron-down',
          text: 'Skedula',
          admin: true,
          model: true,
          children: [
            { icon: 'sync_alt', text: 'Sync', path: '/skedula'}
          ],
        }
      ],
    }),
    watch: {
      'search.text': function (val) {
        var self = this
        clearTimeout(this.search._timerId);
        var search = this.search
        if (val.length > 3) {
          search.loading = true;
           // delay new call 500ms
           search._timerId = setTimeout(() => {
              self.runSearch()
           }, 500);
        }
      }
    },
    created () {
      this.$vuetify.theme.dark = false
    },
    mounted: function () {
      var self = this
      fb.session.user.getClasses.then((data)=>{
        data.forEach((item, i) => {
          self.userClasses.classes.push(item)
        });
      })
    },
    methods: {
      // https://github.com/vuejs-templates/browserify-simple/issues/6
      openClass: function (item) {
        console.log(item)
      },
      open: function (item) {
        if (item.text === 'Logout') {
          console.log('signout')
          fb.auth.signOut()
        }
        if (item.path) {
          this.$router.push(item).catch(err => {
              // Ignore the vuex err regarding  navigating to the page they are already on.
              if (
                err.name !== 'NavigationDuplicated' &&
                !err.message.includes('Avoided redundant navigation to current location')
              ) {
                // But print any other errors to the console
                logError(err);
              }
            });
        }
      },
      runSearch: function () {
        this.search.menu = true
        clearTimeout(this.search._timerId)
        this.search._timerId = null
        api.get('search', { searchText: this.search.text }, (data) => {
          this.search.loading = false
          this.search.results = data
          console.log(data)
        })
      },
      logout: function () {
        fb.auth.signOut()
      }
    }
  }
</script>
